export default __webpack_public_path__ + "static/jardinEncantado-4dad11a1a58709349e018f8083b9e2c0.png";